import { render, staticRenderFns } from "./TableCompanies.vue?vue&type=template&id=1d6b7ac8"
import script from "./TableCompanies.vue?vue&type=script&lang=js"
export * from "./TableCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports